export const formatCompactRM = (num: number): string => {
  const abs = Math.abs(num);
  if (abs >= 1e9) return `RM ${(num / 1e9).toFixed(1)}B`;
  if (abs >= 1e6) return `RM ${(num / 1e6).toFixed(1)}M`;
  if (abs >= 1e3) return `RM ${(num / 1e3).toFixed(1)}k`;
  return `RM ${Number(num).toLocaleString()}`;
};

export const formatRM = (num: number): string => {
  return `RM ${Number(num).toLocaleString()}`;
};

export const formatRMFixed2 = (num: number | undefined | null): string => {
  const value = Number(num ?? 0);
  return `RM ${value.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatCurrency = (value: number): string => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "MYR",
  }).format(value);
};

export const formatCurrencyWithCommas = (value: number): string => {
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
